import React, { useState, useEffect, useContext, useRef } from "react";
import "../../../../constants/report.css";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../../contexts/ContextProvider";
import { Loader } from "../../../../components";
import { formatDate } from "../../../../constants/helper";
import {
  Box,
  ButtonGroup,
  Button,
  Autocomplete,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import { Container, Form, Row, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import { useDownloadExcel } from "react-export-table-to-excel";
import SearchIcon from "@mui/icons-material/Search";
import PrintIcon from "@mui/icons-material/Print";
import { useReactToPrint } from "react-to-print";
import useScreenWidth from "../../../../hooks/useScreenWidth";

const LaporanPenjualanPerMekanik = () => {
  const screenSize = useScreenWidth();
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const reportTemplateRef = useRef(null);
  let nowDate = new Date();
  let [sampaiTanggal, setSampaiTanggal] = useState(
    new Date(user.tutupperiode.sampaiTanggal)
  );
  let [dariTanggal, setDariTanggal] = useState(
    new Date(user.tutupperiode.dariTanggal)
  );
  const [kodeCabang, setKodeCabang] = useState("");
  const [namaCabang, setNamaCabang] = useState("");

  const [cabangs, setCabangs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [persenLoading, setPersenLoading] = useState("0");
  const [lapPenjualanPerHaris, setLapPenjualanPerHaris] = useState([]);
  const [previewPdf, setPreviewPdf] = useState(false);
  const [isCetakExcel, setIsCetakExcel] = useState(false);
  const [error, setError] = useState(false);

  const [filter, setFilter] = useState("REKAP");

  const handleChangeFilter = (event) => {
    setFilter(event.target.value);
    setLapPenjualanPerHaris([]);
    setPreviewPdf(false);
  };

  let cabangOptions = cabangs.map((cabang) => ({
    label: `${cabang.id} - ${cabang.namaCabang}`,
    id: `${cabang.id} - ${cabang.namaCabang}`,
  }));

  const generatePDF = useReactToPrint({
    content: () => reportTemplateRef.current,
    documentTitle: "LaporanPenjualanPerMekanik",
  });

  const tampilPdf = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setLoading(true);
      let tempPersenLoading = parseInt(persenLoading);

      setTimeout(() => {
        tempPersenLoading += 40;
        setPersenLoading(tempPersenLoading.toString());
      }, "1000");

      if (filter === "REKAP") {
        let laporanPenjualanPerMekanik = await axios.post(
          `${tempUrl}/laporanPenjualanPerMekanikRekap`,
          {
            dariTanggal,
            sampaiTanggal,
            kodeCabang,
            _id: user.id,
            token: user.token,
          }
        );
        setLapPenjualanPerHaris(laporanPenjualanPerMekanik.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      } else {
        let laporanPenjualanPerMekanik = await axios.post(
          `${tempUrl}/laporanPenjualanPerMekanikRinci`,
          {
            dariTanggal,
            sampaiTanggal,
            kodeCabang,
            _id: user.id,
            token: user.token,
          }
        );
        setLapPenjualanPerHaris(laporanPenjualanPerMekanik.data);
        setPreviewPdf(!previewPdf);
        setLoading(false);
        setTimeout(() => {
          tempPersenLoading = 0;
          setPersenLoading(tempPersenLoading.toString());
        }, "2000");
      }
    }
  };

  useEffect(() => {
    getCabangsData();
    if (user.tipeUser !== "OWNER/DIREKSI") {
      setKodeCabang(user.cabang.id);
      setNamaCabang(`${user.cabang.id} - ${user.cabang.namaCabang}`);
    }
  }, []);

  const getCabangsData = async () => {
    const response = await axios.post(`${tempUrl}/cabangs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCabangs(response.data);
  };

  const tableText = {
    letterSpacing: "0.01px",
  };

  const textBold = {
    fontWeight: 700,
    border: "1px solid black",
  };

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  const textNumberRight = {
    textAlign: "right",
    border: "1px solid black",
  };

  const textNumberRightBold = {
    textAlign: "right",
    fontWeight: 700,
    border: "1px solid black",
  };

  const list = [];
  const listRinci = [];

  if (filter === "REKAP") {
    let tempTotalTotalNota = 0;
    let tempTotalTotalPenjualanChild = 0;
    let tempNo = 1;

    Object.entries(lapPenjualanPerHaris).map(([mekanikTitle, stokRows]) => {
      tempTotalTotalNota += stokRows.totalNota;
      tempTotalTotalPenjualanChild += stokRows.totalPenjualanChild;

      list.push(
        <tr style={{ ...tableText }}>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {tempNo}
          </td>
          <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
            {mekanikTitle}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? stokRows.totalNota.toLocaleString("en-EN")
              : stokRows.totalNota}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? stokRows.totalPenjualanChild.toLocaleString("en-EN")
              : stokRows.totalPenjualanChild}
          </td>
        </tr>
      );
      tempNo++;
    });
    tempNo = 0;

    list.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={2}
        >
          Total
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalNota.toLocaleString("en-EN")
            : tempTotalTotalNota}
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalPenjualanChild.toLocaleString("en-EN")
            : tempTotalTotalPenjualanChild}
        </td>
      </tr>
    );
  } else {
    let tempTotalQuantity = 0;
    let tempTotalTotalPenjualanChild = 0;

    Object.entries(lapPenjualanPerHaris).map(([mekanikTitle, stokRows]) => {
      listRinci.push(
        <tr style={{ ...tableText, fontWeight: "bold" }}>
          <td
            style={{ paddingLeft: "15px", border: "1px solid black" }}
            colSpan={7}
          >
            Mekanik : {mekanikTitle}
          </td>
        </tr>
      );

      let tempSubtotalQuantity = 0;
      let tempSubtotalTotalPenjualanChild = 0;

      stokRows.map((row, index) => {
        tempSubtotalQuantity += row.quantity;
        tempSubtotalTotalPenjualanChild += row.totalPenjualanChild;

        tempTotalQuantity += row.quantity;
        tempTotalTotalPenjualanChild += row.totalPenjualanChild;

        listRinci.push(
          <tr style={tableText}>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {formatDate(row.penjualan.tglPenjualan)}
            </td>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {row.penjualan.noNotaPenjualan}
            </td>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {row.stok.kodeStok} - {row.stok.namaStok}
            </td>
            <td style={{ paddingLeft: "15px", border: "1px solid black" }}>
              {row.penjualan.namaTipe}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.quantity.toLocaleString("en-EN")
                : row.quantity}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.hargaNetto.toLocaleString("en-EN")
                : row.hargaNetto}
            </td>
            <td style={textNumberRight}>
              {isCetakExcel === false
                ? row.totalPenjualanChild.toLocaleString("en-EN")
                : row.totalPenjualanChild}
            </td>
          </tr>
        );
      });

      listRinci.push(
        <tr style={{ ...tableText, fontWeight: "bold" }}>
          <td
            style={{ paddingLeft: "15px", border: "1px solid black" }}
            colSpan={4}
          >
            Sub Total : {mekanikTitle}
          </td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? tempSubtotalQuantity.toLocaleString("en-EN")
              : tempSubtotalQuantity}
          </td>
          <td style={textNumberRight}></td>
          <td style={textNumberRight}>
            {isCetakExcel === false
              ? tempSubtotalTotalPenjualanChild.toLocaleString("en-EN")
              : tempSubtotalTotalPenjualanChild}
          </td>
        </tr>
      );
    });

    listRinci.push(
      <tr style={{ ...tableText, fontWeight: "bold" }}>
        <td
          style={{ paddingLeft: "15px", border: "1px solid black" }}
          colSpan={4}
        >
          Total :
        </td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalQuantity.toLocaleString("en-EN")
            : tempTotalQuantity}
        </td>
        <td style={textNumberRight}></td>
        <td style={textNumberRight}>
          {isCetakExcel === false
            ? tempTotalTotalPenjualanChild.toLocaleString("en-EN")
            : tempTotalTotalPenjualanChild}
        </td>
      </tr>
    );
  }

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "LaporanPenjualanPerMekanik",
    sheet: "LaporanPenjualanPerMekanik",
  });

  if (loading) {
    return <Loader persenLoading={persenLoading} />;
  }

  return (
    <Container>
      <h3>Laporan</h3>
      <h5 style={{ fontWeight: 400 }}>Laporan Penjualan Per Mekanik</h5>
      <hr />
      <Box sx={spacingTop}>
        <Form onSubmit={tampilPdf}>
          <Row>
            <FormControl sx={{ marginTop: 1 }}>
              <FormLabel id="demo-controlled-radio-buttons-group">
                Filter
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                defaultValue="REKAP"
                value={filter}
                onChange={handleChangeFilter}
              >
                <FormControlLabel
                  value="REKAP"
                  control={<Radio />}
                  label="Rekap"
                />
                <FormControlLabel
                  value="RINCI"
                  control={<Radio />}
                  label="Rinci"
                />
              </RadioGroup>
            </FormControl>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Cabang :
                </Form.Label>
                <Col sm="8">
                  {user.tipeUser === "OWNER/DIREKSI" ? (
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={cabangOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCabang.length === 0 && true}
                          size="small"
                          placeholder="SEMUA CABANG"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCabang(value.id.split(" ", 1)[0]);
                          setNamaCabang(value.id);
                        } else {
                          setKodeCabang("");
                          setNamaCabang("");
                        }
                        setLapPenjualanPerHaris([]);
                        setPreviewPdf(false);
                      }}
                      defaultValue={kodeCabang}
                    />
                  ) : (
                    <Form.Control value={kodeCabang} disabled readOnly />
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Dari :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={dariTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setDariTanggal(date);
                      setLapPenjualanPerHaris([]);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextPassword"
              >
                <Form.Label column sm="4" style={textRight}>
                  Sampai :
                </Form.Label>
                <Col sm="8">
                  <DatePicker
                    required
                    dateFormat="dd/MM/yyyy"
                    selected={sampaiTanggal}
                    customInput={<Form.Control required />}
                    onChange={(date) => {
                      setSampaiTanggal(date);
                      setLapPenjualanPerHaris([]);
                      setPreviewPdf(false);
                    }}
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="contained"
            startIcon={<SearchIcon />}
            type="submit"
            style={{ marginTop: "20px" }}
          >
            LIHAT
          </Button>
        </Form>
      </Box>

      {previewPdf && (
        <div style={{ marginTop: "10px" }}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button startIcon={<PrintIcon />} onClick={generatePDF}>
              PDF
            </Button>
            <Button
              startIcon={<SearchIcon />}
              onClick={() => {
                setIsCetakExcel(true);
                setTimeout(() => {
                  onDownload();
                }, "1000");
              }}
            >
              Excel
            </Button>
          </ButtonGroup>
        </div>
      )}
      <div ref={reportTemplateRef} id="content" style={pdfContainer}>
        <div style={{ visibility: previewPdf === true ? "visible" : "hidden" }}>
          <p>
            {setting.namaPerusahaan} - {setting.alamatPerusahaan}
          </p>
          <p>({setting.kabupatenPerusahaan})</p>
          <p>{setting.kotaPerusahaan}</p>
          <p>NO. TELP. {setting.teleponPerusahaan}</p>
          <p>
            Dicetak Oleh: {user.username} | Tanggal:
            {` ${nowDate.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(nowDate.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${nowDate.getFullYear()} `}{" "}
            | Jam:{" "}
            {` ${nowDate.getHours().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${(nowDate.getMinutes() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}:${nowDate.getSeconds().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })} `}
          </p>
          <h5 style={{ textAlign: "center", fontWeight: "700" }}>
            Laporan Penjualan Per Mekanik
          </h5>
          <p>
            Dari Tanggal :
            {` ${dariTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(dariTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${dariTanggal.getFullYear()}`}
          </p>
          <p>
            Sampai Tanggal :
            {` ${sampaiTanggal.getDate().toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${(sampaiTanggal.getMonth() + 1).toLocaleString("en-US", {
              minimumIntegerDigits: 2,
              useGrouping: false,
            })}/${sampaiTanggal.getFullYear()}`}
          </p>
          <p>Cabang : {namaCabang}</p>
          <p></p>

          {filter === "REKAP" ? (
            <table class="styled-table" ref={tableRef}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid black" }} rowSpan={2}>
                    NO
                  </th>
                  <th style={{ border: "1px solid black" }} rowSpan={2}>
                    MEKANIK
                  </th>
                  <th
                    style={{ border: "1px solid black", textAlign: "center" }}
                    colSpan={3}
                  >
                    OMSET
                  </th>
                </tr>
                <tr>
                  <th style={{ border: "1px solid black" }}>QTY</th>
                  <th style={{ border: "1px solid black" }}>RUPIAH</th>
                </tr>
              </thead>
              <tbody>{list}</tbody>
            </table>
          ) : (
            <table class="styled-table" ref={tableRef}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid black" }} rowSpan={2}>
                    TANGGAL
                  </th>
                  <th style={{ border: "1px solid black" }} rowSpan={2}>
                    NO. NOTA
                  </th>
                  <th style={{ border: "1px solid black" }} rowSpan={2}>
                    STOK
                  </th>
                  <th style={{ border: "1px solid black" }} rowSpan={2}>
                    TIPE
                  </th>
                  <th
                    style={{ border: "1px solid black", textAlign: "center" }}
                    colSpan={3}
                  >
                    OMSET
                  </th>
                </tr>
                <tr>
                  <th style={{ border: "1px solid black" }}>QTY</th>
                  <th style={{ border: "1px solid black" }}>HARGA</th>
                  <th style={{ border: "1px solid black" }}>SUBTOTAL</th>
                </tr>
              </thead>
              <tbody>{listRinci}</tbody>
            </table>
          )}
        </div>
      </div>
    </Container>
  );
};

export default LaporanPenjualanPerMekanik;

const spacingTop = {
  mt: 4,
};

const pdfContainer = {
  padding: "20px",
  letterSpacing: "0.01px",
  fontSize: "10px",
  fontFamily: "sans-serif",
  width: "1000px",
};
